import { Dialog } from 'primereact/dialog'
import React, { useContext, useEffect, useState } from 'react'
import { PrintOut } from './PrintOut'
import { Button } from 'primereact/button'
import { reportService } from '../../services/ReportService'
import { helper } from '../../componets/utils/helper'
import { AppDB } from '../../App'
// 053192455050
export default function PrintOutAction({ showDialog, setShowDialog, applicationID,currentReport="applicant"}) {
    var [showReportDialog, setReportShowDialog] = useState(false)
    var [loading, setLoading] = useState(false)
    var [base64, setBase64] = useState("")
    var { toast } = useContext(AppDB)
    function onGenerateRport(isInternal) {
        setLoading(true)
        reportService
            .getReport({
                "ReportID": 7,
                "ApplicationID": applicationID,
                "IsInternal":isInternal
            })
            .then((res) => {
                setLoading(false)
                if (res?.success === true) {

                    setBase64(res.data)
                    toast.show({ severity: "success", summary: "Success", detail: "Report Loaded", life: 5000 });
                } else {
                    toast.show({ severity: "error", summary: "", detail: "No Data Found", life: 3000 });
                }

            });
    }
    return (
        <>
            <PrintOut base64={base64} setBase64={setBase64} showDialog={showReportDialog} setShowDialog={setReportShowDialog} />
            <Dialog header={`${currentReport==="elector"?"Elector":"Applicant"} Details`} style={{ width: "400px" }} visible={showDialog} onHide={e => setShowDialog(false)}>
                <div>
                    <Button loading={loading} className='w-full mb-3 mt-2' onClick={()=>{
                      onGenerateRport(false);
                      }} label={`For the Applicant`} />
                    <Button loading={loading} className='w-full' onClick={()=>{
                        onGenerateRport(true);
                    }} label={`For Internal Use`} />
                    <Button loading={loading}
                        className='p-button-danger mt-2'
                        onClick={()=>setShowDialog(false)} 
                        label="Close"
                        style={{ float: 'right' }}
                    />
                </div>
            </Dialog>
        </>

    )
}
